import React from "react";
import MissionProgress from "components/MissionProgress";
import styled from "@emotion/styled";
import { Link } from "gatsby";

const MissionCardLayout = styled.div`
  background: #1c1c1c;
  display: flex;
  border-radius: 8px;
  padding: 16px;
  color: #fff;
  margin-bottom: 15px;
  justify-content: space-between;
  align-items: center;
`;

const MissionCardDesc = styled.div`
  width: 50%;
`;

const MissionTitle = styled.h4`
  font-family: "Gilroy";
  margin: 0;
`;

const MissionDesc = styled.div`
  margin: 16px 0;
`;

const MissionColor = styled.div`
  background: ${props => props.color};
  color: #fff;
  display: inline-block;
  font-weight: bold;
  padding: 4px 8px;
`;

const MissionProgressLayout = styled.div`
  width: 40%;
`;

export default function MissionCard(props) {
  const { braceletName, braceletColor } = props;

  return (
    <Link to="/play/mission">
      <MissionCardLayout>
        <MissionCardDesc>
          <MissionTitle>COLOR MISSION</MissionTitle>
          <MissionDesc>
            Get 1500 points by visiting all booths with your bracelet color
          </MissionDesc>
          <MissionColor color={braceletColor}>{braceletName}</MissionColor>
        </MissionCardDesc>
        <MissionProgressLayout>
          <MissionProgress {...props} />
        </MissionProgressLayout>
      </MissionCardLayout>
    </Link>
  );
}
